module.exports = require("./createClass.js");


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/create-class.js
// module id = 417
// module chunks = 168707334958949